import {Component, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

interface IRadioDropdownButton {
  value: (number | boolean | string);
  label: string;
  id?: number;
  e2eId?: string;
}

export interface IRadioButtonsDropdown {
  buttons: IRadioDropdownButton[];
  groupName: string;
}

@Component({
  selector: 'app-radio-buttons-with-dropdown',
  templateUrl: './radio-buttons-with-dropdown.component.html',
  styleUrls: ['./radio-buttons-with-dropdown.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: RadioButtonsWithDropdownComponent,
    multi: true
  }]
})

export class RadioButtonsWithDropdownComponent implements ControlValueAccessor, OnInit {

  @Input() buttonValues: IRadioButtonsDropdown;
  selectedValue;
  dropdownValue;
  radioButtons: IRadioDropdownButton[] = [];
  dropdownButtons: IRadioDropdownButton[] = [];
  maxDisplayedButtons = 3;

  onChange: any = () => {};
  onTouch: any = () => {};

  get buttons(): IRadioDropdownButton[] | null {
    return this.buttonValues?.buttons;
  }

  constructor() {
  }

  ngOnInit(): void {
    if (this.buttons && this.maxDisplayedButtons) {
      this.radioButtons = this.buttons.filter((button, index) => index < this.maxDisplayedButtons);
      this.dropdownButtons = this.buttons.filter((button, index) => index >= this.maxDisplayedButtons);
    }
  }

  writeValue(value: (number | string)): void {
    this.dropdownValue = this.dropdownButtons.find(button => button.value?.toString() === value?.toString()) ? value : null;
    this.selectedValue = value;
    this.onChange(value);
    this.onTouch(value);
  }

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouch = fn; }
}
